export default parseInt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/to-integer.js
// module id = 75
// module chunks = 0